import React from 'react';
import { Navigate } from 'react-router';
import { Spin } from 'antd';
import { useProject } from '../hooks';

export const ProjectPhaseRedirect: React.FC = () => {
  const { project, activePhase, loading } = useProject();

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '200px' }}>
        <Spin />
      </div>
    );
  }

  const targetPhaseId = activePhase?.id || project?.phases?.[0]?.id;

  if (!project || !targetPhaseId) {
    return null;
  }

  const targetPath = `/project/${project.id}/phase/${targetPhaseId}`;
  return <Navigate to={targetPath} replace />;
};
